import { Component } from '@angular/core';
import { ScreenSeatsComponent } from 'libs/shared/src/lib/component/screen/seats/seats.component';

@Component({ standalone: false, selector: 'app-screen-seats', templateUrl: './seats.component.html' })
export class CustomScreenSeatsComponent extends ScreenSeatsComponent {}
